import * as React from "react";
import type { SVGProps } from "react";
const SvgTradingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="trading_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 853.333c-188.672 0-341.333-152.661-341.333-341.333 0-188.672 152.661-341.333 341.333-341.333 188.672 0 341.333 152.661 341.333 341.333 0 188.672-152.661 341.333-341.333 341.333zm0 85.334c235.776 0 426.667-190.891 426.667-426.667S747.776 85.333 512 85.333 85.333 276.224 85.333 512 276.224 938.667 512 938.667z"
    />
    <path
      fill="currentColor"
      d="m588.373 633.6 182.912-174.933a44.394 44.394 0 0 0 10.07-14.08 42.07 42.07 0 0 0-9.686-48.086 46.635 46.635 0 0 0-63.957.555l-149.76 143.317-87.51-90.922a46.507 46.507 0 0 0-65.365-.768l-136.32 134.741A42.539 42.539 0 0 0 256 614.485a42.667 42.667 0 0 0 13.91 30.55c8.66 7.936 20.138 12.245 32 12.032 11.775-.214 23.125-4.864 31.445-13.142l103.21-101.973 86.998 90.325c4.096 4.31 9.088 7.723 14.592 10.112a46.507 46.507 0 0 0 50.218-8.789z"
    />
  </svg>
);
export default SvgTradingIcon;
